import React from 'react';
import { Routes, Route } from 'react-router-dom';
import StaffDashboard from './StaffDashboard';
import Attendance from './staff/Attendance';
import LessonPlan from './staff/LessonPlan';
import Assessment from './staff/Assessment';
import Clinical from './staff/Clinical';
import Rotation from './staff/Rotation';
import Notices from './staff/Notices';
import Library from './staff/Library';
import Reports from './staff/Reports';
import Settings from './Settings';
import StaffProfile from '../components/StaffProfile';
import './staff/staff-modules.css';

function StaffPage({ user, token, onLogout }) {
  return (
    <div className="staff-page">
      <Routes>
        <Route path="/" element={<StaffDashboard user={user} token={token} />} />
        <Route path="attendance" element={<Attendance user={user} token={token} />} />
        <Route path="lessonplan" element={<LessonPlan user={user} token={token} />} />
        <Route path="assessment" element={<Assessment user={user} token={token} />} />
        <Route path="clinical" element={<Clinical user={user} token={token} />} />
        <Route path="rotation" element={<Rotation user={user} token={token} />} />
        <Route path="notices" element={<Notices user={user} token={token} />} />
        <Route path="library" element={<Library user={user} token={token} />} />
        <Route path="reports" element={<Reports user={user} token={token} />} />
        <Route path="settings" element={<Settings user={user} token={token} onLogout={onLogout} />} />
        <Route path="profile" element={<StaffProfile user={user} token={token} />} />
      </Routes>
    </div>
  );
}

export default StaffPage;